import { Form, FormProps } from 'antd';
import { ReactNode, useState } from 'react';
import './index.scss';
type LayoutType = Parameters<typeof Form>[0]['layout'];

function FormWrap(props: FormProps & { children: ReactNode }) {
  const [formLayout, setFormLayout] = useState<LayoutType>(props.layout || 'vertical');

  const formItemLayout = formLayout === 'horizontal' ? { labelCol: { span: 4 }, wrapperCol: { span: 14 } } : null;

  return (
    <Form
      {...props}
      className={`ant-custom-form-wrap w-100 ${props?.className ?? ''}`}
      {...formItemLayout}
      layout={formLayout}
      form={props.form}
      // initialValues={{ layout: formLayout }}
      style={{ maxWidth: formLayout === 'inline' ? 'none' : '' }}
    >
      {/* <Form.Item label="Form Layout" name="layout">
        <Radio.Group value={formLayout}>
          <Radio.Button value="horizontal">Horizontal</Radio.Button>
          <Radio.Button value="vertical">Vertical</Radio.Button>
          <Radio.Button value="inline">Inline</Radio.Button>
        </Radio.Group>
      </Form.Item> */}
      {props.children}
    </Form>
  );
}

export default FormWrap;
